import {
    NOTIFICATION_DELETE_ITEMS,

    NOTIFICATION_DELETE_ITEMS_ERROR, NOTIFICATION_DELETE_ITEMS_SUCCESS, NOTIFICATION_GET_LIST,

    NOTIFICATION_GET_LIST_ERROR,


    NOTIFICATION_GET_LIST_SEARCH, NOTIFICATION_GET_LIST_SUCCESS,

    NOTIFICATION_GET_LIST_WITH_FILTER,
    NOTIFICATION_GET_LIST_WITH_ORDER,

    NOTIFICATION_SELECTED_ITEMS_CHANGE
} from './actions_def';

const INIT_STATE = {
    items: null,
    errors: [],
    filter: null,
    searchKeyword: '',
    orderColumn: null,
    isLoaded: false,
    isLoading: false,
    saving: false,
    labels: [
        { label: 'EDUCATION', color: 'secondary' },
        { label: 'NEW FRAMENOTIFICATION', color: 'primary' },
        { label: 'PERSONAL', color: 'info' },
    ],
    orderColumns: [
        { column: 'title', label: 'Title' },
        { column: 'category', label: 'Category' },
        { column: 'status', label: 'Status' },
        { column: 'label', label: 'Label' },
    ],
    categories: ['Flexbox', 'Sass', 'React'],
    selectedItems: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case NOTIFICATION_GET_LIST:
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
            };

        case NOTIFICATION_GET_LIST_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                items: action.payload,
            };

        case NOTIFICATION_GET_LIST_ERROR:
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                error: action.payload
            };

        case NOTIFICATION_GET_LIST_WITH_FILTER:
            if (action.payload.column === '' || action.payload.value === '') {
                return {
                    ...state,
                    isLoaded: false,
                    isLoading: true,
                    items: state.items,
                    filter: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const filteredItems = state.items.filter(
                (item) => item[action.payload.column] === action.payload.value
            );
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                items: filteredItems,
                filter: {
                    column: action.payload.column,
                    value: action.payload.value,
                },
            };

        case NOTIFICATION_GET_LIST_WITH_ORDER:
            if (action.payload === '') {
                return {
                    ...state,
                    isLoaded: false,
                    isLoading: true,
                    items: state.items,
                    orderColumn: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const sortedItems = state.items.sort((a, b) => {
                if (a[action.payload] < b[action.payload]) return -1;
                if (a[action.payload] > b[action.payload]) return 1;
                return 0;
            });
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
                items: sortedItems,
                orderColumn: state.orderColumns.find(
                    (x) => x.column === action.payload
                ),
            };

        case NOTIFICATION_GET_LIST_SEARCH:
            if (action.payload === '') {
                return { ...state, items: state.items };
            }
            // eslint-disable-next-line no-case-declarations
            const keyword = action.payload.toLowerCase();
            // eslint-disable-next-line no-case-declarations
            const searchItems = state.items.filter(
                (item) =>
                    item.title.toLowerCase().indexOf(keyword) > -1 ||
                    item.detail.toLowerCase().indexOf(keyword) > -1 ||
                    item.status.toLowerCase().indexOf(keyword) > -1 ||
                    item.category.toLowerCase().indexOf(keyword) > -1 ||
                    item.label.toLowerCase().indexOf(keyword) > -1
            );
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
                items: searchItems,
                searchKeyword: action.payload,
            };

        case NOTIFICATION_SELECTED_ITEMS_CHANGE:
            return {
                ...state, isLoaded: false,
                isLoading: false, selectedItems: action.payload
            };

        case NOTIFICATION_DELETE_ITEMS:
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
                saving: true
            };

        case NOTIFICATION_DELETE_ITEMS_SUCCESS:

            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                saving: false,
                saved: true,
                errors: [],
                items: state.items.filter(item => item.id !== action.payload.rfc_id),
                items: state.items.filter(item => item.id !== action.payload.rfc_id),
            };

        case NOTIFICATION_DELETE_ITEMS_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                saving: false,
                saved: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        default:
            return { ...state };
    }
};
